var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const pbjsResolver = (resolve) => window.pbjs.que.push(() => resolve(window.pbjs));
export function loadPrebid(cfg) {
    return __awaiter(this, void 0, void 0, function* () {
        if (window.pbjs)
            return new Promise(pbjsResolver);
        window.pbjs = { que: [] };
        window.pbjs.que.push(() => configurePrebid(cfg));
        const container = document.head || document.body;
        const script = Object.assign(document.createElement('script'), { src: cfg.config.bundleUrl, async: true, defer: true });
        container.appendChild(script);
        return new Promise(pbjsResolver);
    });
}
export function configurePrebid(cfg) {
    const prebid = window.pbjs;
    const allBids = [...cfg.config.bids, ...cfg.videoConfig.bids];
    prebid.bidderSettings = {
        deviceAccess: true,
        standard: {
            storageAllowed: true,
            adserverTargeting: [
                { key: 'hb_cpm', val(bid) { return bid.cpm.toFixed(2); } },
                { key: 'hb_pb', val(bid) { return bid.cpm.toFixed(2); } },
                { key: 'hb_adid', val(bid) { return bid.adId; } },
                { key: 'hb_bidder', val(bid) { return bid.adapterCode; } },
                { key: 'hb_adomain', val: (resp) => { var _a; return ((_a = resp.meta) === null || _a === void 0 ? void 0 : _a.advertiserDomains) && resp.meta.advertiserDomains[0]; } },
            ]
        },
        pubmatic: { bidCpmAdjustment: (cpm) => cpm * 0.8 },
        rubicon: { bidCpmAdjustment: (cpm) => cpm * 0.8 },
        improvedigital: { bidCpmAdjustment: (cpm) => cpm * 0.75 },
        smaato: { bidCpmAdjustment: (cpm) => cpm * 0.75 },
        smartadserver: { bidCpmAdjustment: (cpm) => cpm * 0.8 },
        spotx: { bidCpmAdjustment: (cpm) => cpm * 0.75 },
    };
    const schain = cfg.schain ? {
        validation: 'relaxed',
        config: {
            ver: '1.0',
            complete: 1,
            nodes: [{ asi: 'arkadium.com', sid: cfg.schain, hp: 1 }],
        },
    } : null;
    prebid.setConfig({
        schain,
        consentManagement: {},
        firstPartyData: { enabled: true, skipEnrichments: false },
        gptPreAuction: { enabled: true, mcmEnabled: true },
        enableTIDs: true,
        bidderSequence: 'random',
        bidderTimeout: 1000,
        deviceAccess: true,
        pageUrl: document.location.href,
        useBidCache: true,
        enableSendAllBids: false,
        cache: { url: 'https://prebid.adnxs.com/pbc/v1/cache', ignoreBidderCacheKey: false },
        improvedigital: { usePrebidSizes: true },
        userSync: {
            iframeEnabled: true,
            syncEnabled: true,
            syncsPerBidder: 50,
            syncDelay: 100,
            auctionDelay: 300,
            filterSettings: {
                all: { bidders: '*', filter: 'include' },
            },
            userIds: cfg.config.userIds,
        },
        s2sConfig: {
            enabled: true,
            defaultVendor: 'rubicon',
            accountId: '17214',
            bidders: allBids.filter(b => b.isServer).map(b => b.bidder),
            timeout: 1000,
        },
        priceGranularity: {
            buckets: [
                { precision: 2, max: 50, increment: 0.01 },
            ],
        },
        floors: {
            data: {
                schema: { fields: ['mediaType', 'size'] },
                values: { 'banner|*': 0.05 },
                default: 0.05,
            }
        },
        bidViewability: {
            enabled: true,
            firePixels: true,
        },
        disableAjaxTimeout: true,
        allowActivities: {
            accessDevice: { default: true },
            enrichEids: { default: true },
            enrichUfpd: { default: true },
            fetchBids: { default: true },
            syncUser: { default: true },
            transmitEids: { default: true },
            transmitPreciseGeo: { default: true },
            transmitTid: { default: true },
            transmitUfpd: { default: true },
        }
    });
    if (cfg.config.analytics && cfg.config.analytics.length > 0) {
        prebid.enableAnalytics(cfg.config.analytics);
    }
}
